module.exports = __webpack_public_path__ + "static/media/privacy-policy.6a6c3068.png";